// src/data/projects.js
//
// Fuente de datos centralizada de evidencias fotográficas de proyectos/actividades
// en campo de Servipúblicos Ceilán.
//
// Objetivo: que "Proyectos Recientes" (Home) y "Mejoras" (Projects) consuman la
// misma información sin duplicar textos ni rutas de imagen, y que en el futuro
// sea sencillo reemplazar este archivo por una API/CMS o un módulo de carga de
// evidencias sin tener que tocar los componentes que lo consumen.
//
// Cada imagen se referencia con una ruta relativa a `src/assets/Images` (la
// misma carpeta que ya usa `utils/imageLoader.js` para el resto del sitio), de
// forma que Webpack la optimice, la incluya en el bundle con hash de caché y
// permita el `loading="lazy"` nativo del navegador.
//
// Convención de carpetas de evidencias:
//   src/assets/Images/Projects/<categoria>/<categoria>-NNN.jpg
//
// Para agregar una evidencia nueva más adelante (manual o vía un futuro panel
// de carga): copiar la imagen a la carpeta de su categoría con el siguiente
// número consecutivo y agregar su ruta al arreglo `images` del proyecto
// correspondiente (o crear un proyecto nuevo siguiendo la misma forma).

const evidenceProjects = [
  {
    id: "tanque-almacenamiento-esperanza",
    category: "Instalaciones",
    title: "Tanque de almacenamiento – Barrio La Esperanza",
    description:
      "Adecuación del terreno, tendido de tubería e instalación de un nuevo tanque de almacenamiento de agua para el barrio La Esperanza.",
    cover: "Projects/tanque-almacenamiento/tanque-001.jpg",
    images: [
      {
        src: "Projects/tanque-almacenamiento/tanque-001.jpg",
        alt: "Adecuación del terreno para el nuevo tanque de almacenamiento de agua",
      },
      {
        src: "Projects/tanque-almacenamiento/tanque-002.jpg",
        alt: "Excavación e instalación de tubería para el nuevo tanque de almacenamiento",
      },
      {
        src: "Projects/tanque-almacenamiento/tanque-003.jpg",
        alt: "Cuadrilla instalando la tubería de conexión del tanque de almacenamiento",
      },
      {
        src: "Projects/tanque-almacenamiento/tanque-004.jpg",
        alt: "Conexión de tubería en la zanja de instalación del tanque",
      },
      {
        src: "Projects/tanque-almacenamiento/tanque-005.jpg",
        alt: "Tanque de almacenamiento de agua ya instalado en el terreno adecuado",
      },
      {
        src: "Projects/tanque-almacenamiento/tanque-006.jpg",
        alt: "Transporte del tanque de almacenamiento de 6000 litros hacia el barrio La Esperanza",
      },
    ],
  },
  {
    id: "acueducto-ptap",
    category: "Infraestructura",
    title: "Planta de tratamiento y tanques del acueducto",
    description:
      "Registro fotográfico de las estructuras de tratamiento y almacenamiento del acueducto veredal, mantenidas y operadas por Servipúblicos Ceilán.",
    cover: "Projects/acueducto/acueducto-001.jpg",
    images: [
      {
        src: "Projects/acueducto/acueducto-001.jpg",
        alt: "Tanques de tratamiento y almacenamiento del acueducto",
      },
      {
        src: "Projects/acueducto/acueducto-002.jpg",
        alt: "Vista panorámica de los tanques de tratamiento del acueducto",
      },
      {
        src: "Projects/acueducto/acueducto-003.jpg",
        alt: "Senderos y tanques de almacenamiento dentro de las instalaciones del acueducto",
      },
      {
        src: "Projects/acueducto/acueducto-004.jpg",
        alt: "Tanque de almacenamiento con tapa de mantenimiento en las instalaciones del acueducto",
      },
      {
        src: "Projects/acueducto/acueducto-005.jpg",
        alt: "Tanques de tratamiento del acueducto rodeados de vegetación",
      },
      {
        src: "Projects/acueducto/acueducto-006.jpg",
        alt: "Instalaciones del acueducto junto a la vivienda del operador",
      },
    ],
  },
  {
    id: "caminata-bocatoma",
    category: "Caminatas",
    title: "Caminata de inspección a la bocatoma",
    description:
      "Recorrido de la Junta Administradora hasta la bocatoma y la planta de tratamiento del acueducto, verificando el estado de la captación de agua.",
    cover: "Projects/caminatas/caminata-002.jpg",
    images: [
      {
        src: "Projects/caminatas/caminata-001.jpg",
        alt: "Recorrido de campo hacia la bocatoma del acueducto",
      },
      {
        src: "Projects/caminatas/caminata-002.jpg",
        alt: "Integrantes de la Junta Administradora llegando a la planta de tratamiento durante la caminata de inspección",
      },
      {
        src: "Projects/caminatas/caminata-003.jpg",
        alt: "Grupo de la caminata de inspección junto a los tanques del acueducto",
      },
    ],
  },
  {
    id: "alcantarillado-nuevo",
    category: "Obra civil",
    title: "Gestión de alcantarillado nuevo",
    description:
      "Trabajos de excavación e instalación de tubería para la ampliación de la red de alcantarillado.",
    cover: "Projects/alcantarillado/alcantarillado-001.jpg",
    images: [
      {
        src: "Projects/alcantarillado/alcantarillado-001.jpg",
        alt: "Excavación para la instalación de tubería de la nueva red de alcantarillado",
      },
      {
        src: "Projects/alcantarillado/alcantarillado-002.jpg",
        alt: "Cuadrilla y maquinaria trabajando en la instalación de la red de alcantarillado",
      },
    ],
  },
  {
    id: "red-electrica-acueducto",
    category: "Redes",
    title: "Instalación de transformador de energía",
    description:
      "Instalación de un nuevo transformador de energía para garantizar el funcionamiento eléctrico del sistema de acueducto.",
    cover: "Projects/redes/red-002.jpg",
    images: [
      {
        src: "Projects/redes/red-001.jpg",
        alt: "Poste de energía señalado para la instalación del nuevo transformador",
      },
      {
        src: "Projects/redes/red-002.jpg",
        alt: "Cuadrilla técnica instalando el nuevo transformador de energía",
      },
    ],
  },
  {
    id: "inspeccion-institucional",
    category: "Inspecciones",
    title: "Visita técnica institucional",
    description:
      "Visita técnica de funcionarios de la Vallecaucana de Aguas a las instalaciones del acueducto.",
    cover: "Projects/inspecciones/inspeccion-003.jpg",
    images: [
      {
        src: "Projects/inspecciones/inspeccion-001.jpg",
        alt: "Funcionarios en visita técnica a las instalaciones del acueducto",
      },
      {
        src: "Projects/inspecciones/inspeccion-002.jpg",
        alt: "Recorrido técnico junto a los tanques del acueducto",
      },
      {
        src: "Projects/inspecciones/inspeccion-003.jpg",
        alt: "Grupo de funcionarios y personal de Servipúblicos Ceilán durante la visita técnica",
      },
    ],
  },
];

// Proyectos destacados para la sección "Proyectos Recientes" del Home.
// Se referencian por id para no duplicar título/descripción/imagen: el Home
// solo decide CUÁLES mostrar, el contenido siempre sale de `evidenceProjects`.
const featuredProjectIds = [
  "tanque-almacenamiento-esperanza",
  "acueducto-ptap",
  "caminata-bocatoma",
];

export const featuredProjects = featuredProjectIds
  .map((id) => evidenceProjects.find((project) => project.id === id))
  .filter(Boolean);

export default evidenceProjects;
